const $ = require('jquery');
import _ from "underscore";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import run from '../../utilities/run';
import {validateOnAllSelectChanges} from "../../utilities/select2able";
import render from "../../utilities/render";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import {createPreventDefault} from '../../utilities/general';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
import EditChecker from '../../components/EditChecker/EditChecker';
import {setOptionsForSelect} from '../../utilities/selectorHelpers';


const targetSelector = "#create-update-return-rules-outer";

run(targetSelector, ()=>{
	const el = $(targetSelector);
	createUpdateReturnsRules(el);
	setupEditChecker();
});


	
function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#create-update-return-rules-outer");
  EditChecker.bindCancelButton("#returs-rules-cancel-btn");
}

function createUpdateReturnsRules(el) {
  let modalOrderTable;
  let modalFindProdFromList, submitModalFlowSave;
  let rangeStartDatePicker, rangeEndDatePicker;
  const cancelBtn = el.find("#returns-rules-save-btn");
  const saveBtn = el.find("#returns-rules-save-btn");
  const submitURL = el.data("submit-url");
  const detailURL = el.data("detail-url");
  const productLookUpURL = el.data('product-lookup-url');
  const overrideConditions = el.data('overriding-conditions');
  const catList = el.data('cat-list');
  const inboundClassification = el.data('inbound-classification');
  const facilities = el.data('facilities');
  const inclusionConditions = el.data('inclusion-conditions');	 
  const rangeValId = el.find('#retuns-rules-range-val-id');
  const exactValId = el.find('#retuns-rules-exact-val-id');
  const rangeValBtn = el.find('#retuns-rules-range-val-btn');
  const exactValBtn = el.find('#retuns-rules-exact-val-btn');
  const catListSelect = el.find('#returns-rules-categories-select');
  const facilitiesSelect = el.find('#returs-rules-return-facility-select');
  const overrideConditionsSelect = el.find("#returs-rules-override-condition-select");
  const inclusionConditionsSelect = el.find("#returns-rules-inclusion-select");
  const inboundClassificationSelect = el.find("#returs-rules-inbound-classification-select");
  const rule = el.data("rule");
  let isEdit = false;	
  const skuSelect =  $("#return-rule-sku");
  const returnTypesSelect = $("#return-rule-returntypes"); 
  const brandSelect  = $("#return-rule-brands");
  const modelNumberSelect  = $("#return-rule-model-num");
  const departmentSelect = $("#return-rule-departments");
  const productClassificationSelect  = $("#return-rule-prod");
  const costRetailOptionId = $("#cost-retail-option-id");
  const costOptionId = $("#cost-option-id");
  const retailOptionId = $("#retail-option-id");
  const returnsRulesMaxValId = $("#returns-rules-max-val-id");
  const returnsRulesMinValId = $("#returns-rules-min-val-id");
  
  if(rule != "" && rule.cbrId > 0)
  {
	  isEdit = true;
  }
    
  $(catList).each(function() {
    const option = $('<option />');
    option.attr('value', this.catId).text(this.catName);
    catListSelect.append(option);
  });
  
  rangeValBtn.on("click", function(e){
	 e.preventDefault();
	 rangeValId.show();
	 exactValId.hide();
  });
	 
  exactValBtn.on("click", function(e){
	 e.preventDefault();
	 exactValId.show();
	 rangeValId.hide();
  });
 
	function init()
	{
		generateBtnGroup();
		generateDatePickers();
	}
	
	const select2AjaxDefaults = {
		dataType: 'json',
		delay: 250,
		processResults: function (data, params) {
			params.page = params.page || 1;
			return {
				results: data,
				pagination: {
				more: (params.page * 20) < data.total_count
				}
			};
		},
		cache: true
	};  
	
	const validator = el.validate({
		errorPlacement: function(error, element) {
			let appendClosest = $(element).data('error-placement-append-closest');
			if (appendClosest) {
				$(element).closest(appendClosest).append(error);
			} else {
				error.insertAfter(element);
			}
		}
	});
  
  validator.settings.ignore = ":disabled,:hidden";
	if(isEdit)
	{
		let groupedRelatedSelectData = _(rule.cmrRuleConditions).groupBy(function(obj){
		 return obj.crcName;
		});	
	 
		if(_.toArray(groupedRelatedSelectData.ByValue).length > 0)
		{
			const operator =  groupedRelatedSelectData.ByValue[0].crcOperator;
			const crpKey =  groupedRelatedSelectData.ByValue[0].cmrRuleParams[0].crpKey;
			costRetailOptionId.val(crpKey);
			let costType = "cost";
			
			if(crpKey.indexOf("retail") != -1)
			{
				costOptionId.removeClass("active");
				retailOptionId.addClass("active");
				costType = "retail";
			}else{
				costOptionId.addClass("active");
				retailOptionId.removeClass("active");
			}
			
			if(operator == ">=")
			{
			 $("#returns-rules-exact-val").val(groupedRelatedSelectData.ByValue[0].cmrRuleParams[0].crpValue);
			}
			else if(operator == "between")
			{
				rangeValId.show();
				exactValId.hide();
			 
				let minMaxMap = _(groupedRelatedSelectData.ByValue[0].cmrRuleParams).groupBy(function(obj){
				 return obj.crpKey;
				});	
				
				if(costType == "retail")
				{
				 returnsRulesMaxValId.val(minMaxMap.max_retail[0].crpValue);
				 returnsRulesMinValId.val(minMaxMap.min_retail[0].crpValue);
				}
				else{
				 returnsRulesMaxValId.val(minMaxMap.max_cost[0].crpValue);
				 returnsRulesMinValId.val(minMaxMap.min_cost[0].crpValue);
				}
			}
		}
	 
	 if(_.toArray(groupedRelatedSelectData.ByProduct).length > 0)
		{
			const getCmrRuleParams =  groupedRelatedSelectData.ByProduct[0].cmrRuleParams;
			const relatedSelectPillsArray = _(getCmrRuleParams).pluck("crpValue");
	 		setOptionsForSelect({
			list: getCmrRuleParams,
			valueDataKey: "crpValue",
			textDataKey: "crpValue",
			selectElement: skuSelect,
			initialSelectValue: relatedSelectPillsArray
			});
		}
		
		if(_.toArray(groupedRelatedSelectData.Brand).length > 0)
		{
			const getCmrRuleParams =  groupedRelatedSelectData.Brand[0].cmrRuleParams;
			const relatedSelectPillsArray = _(getCmrRuleParams).pluck("crpValue");
			setOptionsForSelect({
				list: getCmrRuleParams,
				valueDataKey: "crpValue",
				textDataKey: "crpValue",
				selectElement: brandSelect,
				initialSelectValue: relatedSelectPillsArray
			});
		}
	 
		if(_.toArray(groupedRelatedSelectData.ModelNumber).length > 0)
		{
			const getCmrRuleParams =  groupedRelatedSelectData.ModelNumber[0].cmrRuleParams;
			const relatedSelectPillsArray = _(getCmrRuleParams).pluck("crpValue");
			setOptionsForSelect({
				list: getCmrRuleParams,
				valueDataKey: "crpValue",
				textDataKey: "crpValue",
				selectElement: modelNumberSelect,
				initialSelectValue: relatedSelectPillsArray
			});
		}
		
		if(_.toArray(groupedRelatedSelectData.Category).length > 0)
		{
			const getCmrRuleParams =  groupedRelatedSelectData.Category[0].cmrRuleParams;
			const relatedSelectPillsArray = _(getCmrRuleParams).pluck("crpValue");
			setOptionsForSelect({
				list: getCmrRuleParams,
				valueDataKey: "crpId",
				textDataKey: "crpId",
				selectElement: catListSelect,
				initialSelectValue: relatedSelectPillsArray
			});
		}
	 
		if(_.toArray(groupedRelatedSelectData.Department).length > 0)
		{
			const getCmrRuleParams =  groupedRelatedSelectData.Department[0].cmrRuleParams;
			const relatedSelectPillsArray = _(getCmrRuleParams).pluck("crpValue");
			setOptionsForSelect({
				list: getCmrRuleParams,
				valueDataKey: "crpValue",
				textDataKey: "crpValue",
				selectElement: departmentSelect,
				initialSelectValue: relatedSelectPillsArray
			});
		}
		
		
		if(_.toArray(groupedRelatedSelectData.ReturnType).length > 0)
		{
			const getCmrRuleParams =  groupedRelatedSelectData.ReturnType[0].cmrRuleParams;
			const relatedSelectPillsArray = _(getCmrRuleParams).pluck("crpValue");
			setOptionsForSelect({
				list: getCmrRuleParams,
				valueDataKey: "crpValue",
				textDataKey: "crpValue",
				selectElement: returnTypesSelect,
				initialSelectValue: relatedSelectPillsArray
			});
		}
		
		
		if(_.toArray(groupedRelatedSelectData.ProductType).length > 0)
		{
			const getCmrRuleParams =  groupedRelatedSelectData.ProductType[0].cmrRuleParams;
			const relatedSelectPillsArray = _(getCmrRuleParams).pluck("crpValue");
	 		setOptionsForSelect({
				list: getCmrRuleParams,
				valueDataKey: "crpValue",
				textDataKey: "crpValue",
				selectElement: productClassificationSelect,
				initialSelectValue: relatedSelectPillsArray
			});
		}
	} 
	
	skuSelect.select2({
		ajax: {
			...select2AjaxDefaults,
			url:productLookUpURL,
			data: configureDataCallback({paramKey: 'likeSku'})
		},
		minimumInputLength: 3
	});

	function configureDataCallback({paramKey}){
		return function(params){
			return {
				[paramKey] : params.term
			};
		};
	}

	returnTypesSelect.select2({
		tags: true,
		placeholder: "Add a Return Type(s) to include"
	})

	brandSelect.select2({
		tags: true,
		placeholder: "Add a Brand(s) to include"
	})

	modelNumberSelect.select2({
		tags: true,
		placeholder: "Add a Model Number(s) to include"
	})

	departmentSelect.select2({
		tags: true,
		placeholder: "Add a Department(s) to include"
	})

	productClassificationSelect.select2({
		tags: true,
		placeholder: "Add a Product Classification(s) to include"
	})

	
	$(facilities).each(function() {
		const option = $('<option />');
		option.attr('value', this.facId).text(this.facName);
		facilitiesSelect.append(option);
	});

	$(overrideConditions).each(function() {
		const option = $('<option />');
		option.attr('value', this.cdmValue).text(this.cdmMeaning);
		overrideConditionsSelect.append(option);
	});


	$(inclusionConditions).each(function() {
		const option = $('<option />');
		option.attr('value', this.cdmValue).text(this.cdmMeaning);
		inclusionConditionsSelect.append(option);
	});


	$(inboundClassification).each(function() {
		const option = $('<option />');
		option.attr('value', this.cdmValue).text(this.cdmMeaning);
		inboundClassificationSelect.append(option);
	});
  
	$(saveBtn).on("click", function(e){
		e.preventDefault();
		if(validator.elements().valid())
		 {
			const submitModalFlow = new SubmitModalFlow({
			confirmModalTitle: "Save Rule",
			confirmModalBody: '<div class="q-pad-all-xl">Once saved, this rule will become active immediately.</div>',
			confirmModalBtnText: "Confirm",
			onConfirmClick: function() {
				submitModalFlow.showLoadingModal();
				submitReturnRule({url: submitURL, success: returnsRulesSucess, error: returnsRulesError});
				function submitReturnRule({url, success, error}){
					$.ajax({
						data: $('#create-update-return-rules-outer').serialize(),
						url: url,
						dataType:"JSON",
						type: 'POST',
						success: success,
						error: error
					 });
				}
				function returnsRulesSucess(returnRuleId){
					if(returnRuleId > 0){
						EditChecker.setPageClean();
						const detailUrlFullURL = `${detailURL}&returnRuleId=${returnRuleId}`;
						submitModalFlow.showSuccessModal();
						setTimeout(function() {
							location.href = detailUrlFullURL;
						}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
					}else{
						submitModalFlow.showFailureModal();
					}
				}
				function returnsRulesError(){
						submitModalFlow.hideAllModals();
					}
				}
			});
			submitModalFlow.init();
			submitModalFlow.showConfirmModal();
		}
	});
		
	function generateDatePickers() {
		rangeStartDatePicker = el.find('.return-rule-range-start');
		rangeEndDatePicker = el.find('.return-rule-range-end');
		const date = new Date();
		rangeStartDatePicker.datepicker({
			startDate: date,
			todayBtn: "linked",
			keyboardNavigation: false,
			autoclose: true
		});
		rangeEndDatePicker.datepicker({
			startDate: date,
			todayBtn: "linked",
			keyboardNavigation: false,
			autoclose: true
		});
	};

	function generateBtnGroup() {
		const costRetailBtnGroupEl = el.find(".cost-retail-toggler");
		const costRetailBtnGroup = new QuickBtnGroup(costRetailBtnGroupEl, {
			distributeWidth: true
		});
		costRetailBtnGroup.init();
	};

	inclusionConditionsSelect.change(handleInclusionConditionChange);

	function handleInclusionConditionChange() {
		var inclusionOpt = $('#returns-rules-inclusion-select :selected').val();
		if(inclusionOpt == "SKU")
		{
			el.find("#returns-rules-sku-inclusion-id").show();
			el.find("#returns-rules-categories-inclusion-id").hide();
		}
		else if(inclusionOpt == "GAC"){
			el.find("#returns-rules-categories-inclusion-id").show();
			el.find("#returns-rules-sku-inclusion-id").hide();
		}
	};
		
	overrideConditionsSelect.change(handleOverrideConditionChange);
	
	function handleOverrideConditionChange() {
		var overrideOpt = $('#returs-rules-override-condition-select :selected').val();
		if(overrideOpt == "return_facility")
		{
			el.find("#returs-rules-return-facility").show();
			el.find("#returs-rules-inbound-classification").hide();
		}
		else if(overrideOpt == "inbound_classification"){
			el.find("#returs-rules-inbound-classification").show();
			el.find("#returs-rules-return-facility").hide();
		}
	};

	init();

	if(isEdit)
	{
		inclusionConditionsSelect.val(rule.cbrInclusionCondition).trigger('change');
		overrideConditionsSelect.val(rule.returnRules[0].rtrOverrideType).trigger('change');
		inboundClassificationSelect.val(rule.returnRules[0].rtrOverrideValue).trigger('change');
		facilitiesSelect.val(rule.returnRules[0].rtrOverrideValue).trigger('change');
	}else
	{
		inclusionConditionsSelect.val("SKU").trigger('change');
		overrideConditionsSelect.val("inbound_classification").trigger('change');
	}
}




// WEBPACK FOOTER //
// ./src/pages/returnsRules/createUpdate.js